export interface Stage {
    description?: string;
    createDate?: string; // ISO 8601 format
    createdBy?: string;
    updatedBy?: string;
    updatedAt?: string; // ISO 8601 format
    status?: StageStatus;
    campaignId?: number;
    id?: number;
    version?: number;
    stageOrder?: number;
    vehicleGroup?: string;
}

export enum StageStatus {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}
